export default __webpack_public_path__ + "static/media/download-app-mobile.4d80dcac.png";